/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Gear(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={128}
        cy={128}
        r={44}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M183.6638,65.08649a84.52233,84.52233,0,0,1,7.2522,7.2521l27.32234,3.90156A103.36981,103.36981,0,0,1,228.40205,100.801L211.84758,122.8728s.20824,6.83942.00065,10.2547l16.561,22.07863a103.36931,103.36931,0,0,1-10.18033,24.554L190.916,183.66144s-4.689,4.98345-7.25071,7.25163l-3.90155,27.32234a103.36971,103.36971,0,0,1-24.56087,10.16371L133.1325,211.84524a84.521,84.521,0,0,1-10.25609.00006l-22.07863,16.561A103.36914,103.36914,0,0,1,76.2438,218.226L72.343,190.91449a84.521,84.521,0,0,1-7.2522-7.25211l-27.32235-3.90155A103.36968,103.36968,0,0,1,27.60479,155.2l16.55447-22.07178s-.20824-6.83942-.00066-10.2547l-16.561-22.07863a103.37,103.37,0,0,1,10.18033-24.554l27.31149-3.90076a84.52233,84.52233,0,0,1,7.2521-7.2522l3.90156-27.32235a103.37019,103.37019,0,0,1,24.56086-10.1637l22.0704,16.55388a84.52281,84.52281,0,0,1,10.25608-.00007l22.07864-16.561A103.37014,103.37014,0,0,1,179.763,37.775Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default Gear;
